var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 8.25005C24 12.8064 20.3063 16.5 15.75 16.5C15.2241 16.5 14.7098 16.4502 14.2112 16.3561L13.0857 17.6224C12.9801 17.7412 12.8506 17.8362 12.7057 17.9013C12.5608 17.9664 12.4037 18 12.2448 18H10.5V19.875C10.5 20.4963 9.99633 21 9.375 21H7.5V22.875C7.5 23.4963 6.99633 24 6.375 24H1.125C0.503672 24 0 23.4963 0 22.875V19.216C0 18.9176 0.118547 18.6315 0.329484 18.4205L7.91395 10.836C7.64569 10.0225 7.5 9.15333 7.5 8.25C7.5 3.69366 11.1936 4.68755e-05 15.75 4.47777e-10C20.3197 -4.68746e-05 24 3.6802 24 8.25005ZM15.75 6C15.75 7.24266 16.7573 8.25 18 8.25C19.2427 8.25 20.25 7.24266 20.25 6C20.25 4.75734 19.2427 3.75 18 3.75C16.7573 3.75 15.75 4.75734 15.75 6Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.7d5e4dff7ca344683d65518288c0c84d.svg";
export { ForwardRef as ReactComponent };